module.exports = __webpack_public_path__ + "static/100paper_bg2sl-613be40f37714da67bd0353ed7500b6d.jpg";